import {
  Login,
  ResetPassword,
  Dashboard,
  Signup,
  ForgotPassword,
  VerifyEmail,
  VerifyPhone,
  InvoiceDashboard,
  UnsubscribeEmail,
  LoanDashboard,
  LoanInformation,
  LoanReports,
  LoanTransactions,
  LoanSupportTickets,
  SupportTicketDetails,
  Navigator
} from "../pages";
import RBFLMSLayout from '../layouts/rbf_lms/rbf_lms_layout';

export const routerList = [
  {
    path: "/login",
    element: Login,
    private: 0,
    restrictedAfterLogin: true,
  },
  {
    path: "/signup",
    element: Signup,
    private: 0,
    restrictedAfterLogin: true,
  },
  {
    path: "/verification/:id",
    element: VerifyPhone,
    private: 0,
    restrictedAfterLogin: true,
  },
  {
    path: "/forgot-password",
    element: ForgotPassword,
    private: 0,
    restrictedAfterLogin: true,
  },
  {
    path: "/verify-email",
    element: VerifyEmail,
    private: 0,
    restrictedAfterLogin: false,
  },
  {
    path: "/reset-password",
    element: ResetPassword,
    private: 0,
    restrictedAfterLogin: true,
  },
  {
    path: "/unsubscribe",
    element: UnsubscribeEmail,
    private: 0,
    restrictedAfterLogin: false,
  },
  ///////////////////////////////////////////////
  {
    path: "/home",
    element: Navigator,
    private: 1,
  },
  {
    path: "/los/:applicationId/apply",
    element: Dashboard,
    private: 1,
  },
  {
    path: "/invoice/:loanUuid",
    element: InvoiceDashboard,
    private: 1,
  },
  {
    path: "/lms/:loanUUID",
    element: RBFLMSLayout,   // ❤️ LMS Layout applied to all LMS pages
    private: 1,
    header: 0,
    children: [
      { path: "dashboard", element: LoanDashboard },
      { path: "loan-information", element: LoanInformation },
      { path: "transactions", element: LoanTransactions },
      { path: "reports", element: LoanReports },
      { path: "tickets", element: LoanSupportTickets },
      { path: "tickets/:ticketId", element: SupportTicketDetails },
    ],
  }
];
